import { ErrorResponseModel } from './responseModel';

export class UserRequestModel {
  userId: string;
  clientId: string;
  userRole: string;
  // TODO : search params TBD
}

export class UserResponseModel {
  apiResponseStatus: string;
  httpStatus: number;
  message: string;
  data: UserModel;
  // This class contains generic datatype property it may contain variety of data as well as null
  dataEnumerable: any[] = [];
  errors: ErrorResponseModel[] = [];
}

export class UserModel {
  userGuid: string = null;
  iManageUserId: string = '';
  loggedInName: string = '';
  mobile: string = '';
  primaryEmailAddress: string = '';
  secondaryEmailAddress: string = '';
  userRoleName?: string = 'User';
  isTestUser: boolean = false;
  isAllowLogin: boolean = true;
  contact: ConstantOptions = new ConstantOptions();
  action?: string = '';
  expirationInMinutes: number;
  jwtToken: string;
  expiration: string;
  clientGuid: string;
  selected?: boolean;
  roleName?: string = 'Admin';
  disableBtn: boolean;
  isUserVerified: boolean;
  isUserLocked: boolean;
  forceUnlockUser: boolean;
  isSpmEnabled: boolean = false;
  lastLoginDateTime?: string;
}


export class ConstantOptions {
  isSms: boolean = false;
  isEmail: boolean = true;
}

export class UserCSVModel {
  primaryEmailAddress: string = '';
  mobileNumber: string = '';
  status: string = '';
  comment: string = '';
}

export class UserCSVResponseModel {
  apiResponseStatus: string;
  httpStatus: number;
  message: string;
  data: Array<DataCSV>;
  dataEnumerable: Array<[]>;
  errors: Array<ErrorCSV>;
}

export class DataCSV {
  status: string;
}

export class ErrorCSV {
  errorStatus: string;
  userMessage: string;
  devMessage: string;
}

export class UserInfo {
  userType: string;
  loggedInUserId: string;
}

export class UserGetReq {
  userType: string;
  requestedCount: number;
}

/** Logical sort names the API whitelists; anything else falls back to newest-first. */
export type UserSortColumn =
  | 'loggedInName'
  | 'primaryEmailAddress'
  | 'iManageUserId'
  | 'mobile'
  | 'isTestUser'
  | 'isAllowLogin'
  | 'isUserLocked'
  | 'lastLoginDateTime';

/** The four grid columns that can be searched. Keys match UserModel property names. */
export interface UserSearchFilters {
  loggedInName?: string;
  primaryEmailAddress?: string;
  iManageUserId?: string;
  mobile?: string;
}

/** One batch of users, following the same Cursor/Limit contract as the document search. */
export class UserPageRequest {
  limit = 100;
  /** Id of the last user in the previous batch. Null starts at the beginning. */
  cursor: string = null;
  /** That user's sort-column value, passed back untouched - the server casts it to its type. */
  cursorSortKey: string = null;
  ascending = false;
  sortColumn: UserSortColumn = null;
  searchUserName: string = null;
  searchPrimaryEmailAddress: string = null;
  searchIManageUserId: string = null;
  searchMobile: string = null;
  /** Filtered total. Costs a second query, so requested only when the search changes. */
  includeTotalCount = false;
}

/** Last row of a batch: `value` is its id, `value2` its value in the sorted column. */
export interface PageCursor {
  value: string;
  value2: string;
}

/** The page payload returned under `data` by get-client-users-list. */
export interface UserPageData {
  items: UserModel[];
  isMore: boolean;
  cursor: PageCursor;
  totalCount?: number;
}

/** CSV bulk path: resolve these addresses to users, server side. */
export class UserEmailLookupRequest {
  emailAddresses: string[] = [];
}
